import React from 'react';
import { processSteps } from '../mock';

const Process = () => {
  return (
    <section className="relative py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="section-label mb-6">Our Process</div>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <h2 className="font-display text-3xl md:text-5xl font-semibold text-white tracking-tight leading-tight">
            Engineered for <br /> measurable results
          </h2>
          <p className="text-slate-400 max-w-md">
            We combine strategy and engineering to deliver scalable cloud solutions.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {processSteps.map((step) => (
            <div key={step.number} className="card-dark rounded-3xl overflow-hidden group">
              <div className="p-7 pb-4">
                <div className="text-amber-400/80 font-display text-sm mb-3">{step.number}</div>
                <h3 className="text-white text-xl font-semibold mb-3">{step.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">{step.description}</p>
              </div>
              <div className="px-3 pb-3">
                <div className="rounded-2xl overflow-hidden aspect-[16/10]">
                  <img src={step.image} alt={step.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
